/**
 * SettlementPage (정산 화면)
 *
 * 멤버별 지출 비교 및 정산 금액 계산
 */

export function SettlementPage() {
  return (
    <div className="p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">공동 정산</h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          멤버별 지출을 비교하고 정산 금액을 계산하는 화면입니다.
        </p>
        <div className="bg-primary-50 border border-primary-200 dark:bg-primary-900/20 dark:border-primary-800 rounded-lg p-4">
          <p className="text-sm text-primary-800 dark:text-primary-200">
            🚧 Phase 2에서 구현 예정 (N분의1 정산)
          </p>
        </div>
      </div>
    </div>
  )
}
